// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DescriptionValue from './view'

export default function DescriptionValueFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DescriptionValue">
      <DescriptionValue {...props}>
        {children}
      </DescriptionValue>
    </Flow>
  )
}
